var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IQOSTable',{attrs:{"cols":[{
          title: _vm.$t('worker_tips_history.col_date'),
          key: 'closed_at',
          date: true
      },
      {
          title: _vm.$t('worker_tips_history.col_date'),
          key: 'closed_at',
          time: true
      },
      {
          title: _vm.$t('worker_tips_history.col_check'),
          key: 'local_id',
      },
      {
          title: _vm.$t('worker_tips_history.col_total'),
          key: 'total',
          currency: 'code'
      },
      {
          title: _vm.$t('worker_tips_history.col_pay'),
          key: 'pay_method',
      }],"rows":_vm.orders},scopedSlots:_vm._u([{key:"col-pay_method",fn:function(slotProps){return [_vm._v("\n              "+_vm._s(slotProps.rowItem.pay_method ? _vm.$t(("pay_methods." + (slotProps.rowItem.pay_method))) : '')+"\n          ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }